import { render } from "./MaxAttemptsReached.vue?vue&type=template&id=89fae952&scoped=true"
import script from "./MaxAttemptsReached.vue?vue&type=script&lang=js"
export * from "./MaxAttemptsReached.vue?vue&type=script&lang=js"

import "./MaxAttemptsReached.vue?vue&type=style&index=0&id=89fae952&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89fae952"]])

export default __exports__